import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic_arrow_24px_47a805dbb68725a4bc29fbcec5a636f9",
  "use": "ic_arrow_24px_47a805dbb68725a4bc29fbcec5a636f9-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ic_arrow_24px_47a805dbb68725a4bc29fbcec5a636f9\">\n    <path d=\"M19 12l-4.577 4.75-1-1.018 2.789-2.894H5v-1.676h11.212l-2.789-2.894 1-1.018L19 12z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol